import { IonButton, IonCol, IonRow, IonText } from "@ionic/react";
import { useEffect, useState } from "react";
import ReactS3Client from "react-aws-s3-typescript";
import { isAndroid, isBrowser } from "react-device-detect";
import { Carousel } from "react-responsive-carousel";
import { v4 as uuidv4 } from "uuid";
import { makeGETRequest, makePOSTRequest } from "../../request/rawRequest";
import { uploadFileToIos } from "../../utils/uploadImageToIOS";
import {
  ACCESS_KEY,
  REGION,
  S3_BUCKET,
  SECRET_ACCESS_KEY,
} from "../../variables/s3Variables";

const s3Config = {
  bucketName: S3_BUCKET,
  region: REGION,
  accessKeyId: ACCESS_KEY,
  secretAccessKey: SECRET_ACCESS_KEY,
};

interface Props {}
const AddPost: React.FC<Props> = ({}) => {
  const [files, setFiles] = useState<File[]>([]);
  const [images, setImages] = useState<any[]>([]);

  const uploadToS3Bucket = async (files: File[]) => {
    let username: string = "";
    await makeGETRequest("/me").then((response) => {
      username = response.email;
    });

    const linkArray: Array<string> = [];
    const uuid = uuidv4();
    const s3 = new ReactS3Client({
      ...s3Config,
      dirName: `${username}/${uuid}`,
    });

    for (const file of files) {
      try {
        const res = await s3.uploadFile(file);
        linkArray.push(res.location);
      } catch (exception) {
        console.error(exception);
      }
    }

    await makePOSTRequest("/feed", {
      picture_url: linkArray,
    }).then(() => {
      window.location.reload();
    });
  };

  useEffect(() => {
    const imagesLoad: any[] = [];
    const fileReaders = [];

    files.forEach((file) => {
      const fileReader = new FileReader();

      fileReaders.push(fileReader);
      fileReader.onload = (e) => {
        const { result } = e.target!;
        if (result) {
          imagesLoad.push(result);
        }
        if (imagesLoad.length === files.length) {
          setImages([...imagesLoad]);
        }
      };
      fileReader.readAsDataURL(file);
    });

    if (files.length > 4) setFiles((old) => old.slice(0, 4));
  }, [files]);

  return (
    <IonRow className="ion-justify-content-center">
      <IonCol>
        <IonRow>
          <IonText color="black" className="ion-text-start">
            Ajoutez plusieurs photos de vos réalisations. Vous pouvez en ajouter
            jusqu'à 4.
          </IonText>
        </IonRow>
        <IonRow className="ion-justify-content-center">
          <IonCol sizeSm="6">
            {isAndroid || isBrowser ? (
              <div>
                <label
                  htmlFor="upload-photo"
                  style={{
                    cursor: "pointer",
                    border: "solid 2px var(--ion-color-primary-contrast)",
                    borderRadius: 20,
                    padding: 5,
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    boxShadow: "0px 5px 5px -3px rgba(0,0,0,0.75)",
                  }}
                >
                  Selectionner vos photos
                </label>
                <input
                  type="file"
                  accept="image/png, image/gif, image/jpeg"
                  multiple={false}
                  name="photo"
                  id="upload-photo"
                  style={{
                    opacity: "0",
                    position: "absolute",
                    zIndex: "-1",
                  }}
                  onChange={(e) => {
                    const file = e.target.files?.item(0);
                    if (file !== null && file !== undefined) {
                      setFiles((old) => [...old, file]);
                    }
                  }}
                />
              </div>
            ) : (
              <IonButton
                fill="solid"
                shape="round"
                expand="full"
                style={{
                  "--border-color": "var(--ion-color-primary-contrast)",
                  "--border-style": "solid",
                  "--border-width": "2px",
                }}
                onClick={() => {
                  uploadFileToIos((file) => {
                    setFiles((old) => [...old, file]);
                  });
                }}
              >
                Selectionner vos photos
              </IonButton>
            )}
            {
              <div
                className="input-send btn"
                style={{
                  backgroundColor: files.length > 0 ? "" : "silver",
                  marginTop: 15,
                  padding: 5,
                }}
                onClick={() => {
                  files.length > 0 && uploadToS3Bucket(files);
                }}
              >
                Envoyer
              </div>
            }
          </IonCol>
        </IonRow>
        <IonRow>
          <Carousel
            autoPlay={false}
            infiniteLoop={true}
            showArrows={true}
            showStatus={true}
            showThumbs={false}
            showIndicators={true}
            emulateTouch={true}
            swipeable={true}
            className="input-carousel"
          >
            {images.map((img, i) => {
              return (
                <img
                  src={img}
                  key={i}
                  className="input-img"
                  alt={"realisations n°" + i}
                ></img>
              );
            })}
          </Carousel>
        </IonRow>
      </IonCol>
    </IonRow>
  );
};

export default AddPost;
